import React from 'react';
import { Container } from 'semantic-ui-react';
import Link from './Link';

const QuickLinks = (props) => {
  const { childPages } = props;

  return (
    <Container>
      <div className="grid-wrapper">
        <div className="super-template-quick-links__container">
          <h3 className="super-template-quick-links__title heading-four">Quicklinks</h3>
          <ul className="super-template-quick-links__items">
            {childPages.map((child, i) => (
              <li className="super-template-quick-links__item" key={i}>
                <Link
                  to={child.node.link}
                  className="internal-link super-template-quick-links__link no-decoration"
                >
                  {child.node.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Container>
  );
};

export default QuickLinks;
